import { EnvironmentUrls } from 'Roblox';
import accountSettingsModule from '../accountSettingsModule';

function usersService($q, $log, httpService) {
  'ngInject';

  return {
    updateDisplayName: (userId, newDisplayName) => {
      const urlConfig = {
        url: `${EnvironmentUrls.usersApi}/v1/users/${userId}/display-names`,
        withCredentials: true
      };
      const requestModel = { newDisplayName };
      return httpService.httpPatch(urlConfig, requestModel);
    },

    validateDisplayName: (userId, newDisplayName) => {
      const urlConfig = {
        url: `${EnvironmentUrls.usersApi}/v1/users/${userId}/display-names/validate?displayName=${newDisplayName}`,
        withCredentials: true
      };
      return httpService.httpGet(urlConfig);
    }
  };
}

accountSettingsModule.factory('usersService', usersService);

export default usersService;
